export default "__VITE_ASSET__DIVHP$jl__"